import CryptoJS from "crypto-js";

class Storage {
    private key = '';
    private type = '';
    private secretKey = '';
    private defaultValue: any;

    constructor(key: string, type: string, defaultValue: any = {}) {
        this.setKey(key);
        this.setType(type);
        this.setSecretKey('efhZpiLhxB73XN79x6obbXcn');
        this.setDefaultValue = defaultValue;
    }

    public save(value: any) {
        const encryptedData = this.encryptData(value);
        this.getStorage().setItem(this.getKey(), encryptedData);
    }

    public get(): any {
        return this.decryptData((this.getStorage().getItem(this.getKey()) || '') as string) || this.getDefaultValue();
    }

    public remove() {
        return this.getStorage().removeItem(this.getKey());
    }

    private encryptData(data: any): string {
        return CryptoJS.AES.encrypt(JSON.stringify(data), this.getSecretKey()).toString();
    }

    private decryptData(encryptedData: string) {
        let result = {}
        try {
            if (!encryptedData) {
                return {};
            }
            const bytes = CryptoJS.AES.decrypt(encryptedData, this.getSecretKey());
            result = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        } catch (error) {
            console.error(error);
        }
        return result
    }

    private getKey(): string {
        if (!this.key) {
            throw new Error('Não foi possível recuperar o valor da chave');
        }
        return 'tbkpay:' + this.key;
    }

    private getSecretKey(): string {
        if (!this.secretKey) {
            throw new Error('Não foi possível recuperar password');
        }
        return this.secretKey;
    }

    private setSecretKey(secretKey: string) {
        if (!secretKey) {
            throw new Error('Não foi possível atribuir password');
        }
        this.secretKey = secretKey;
    }

    private setKey(key: string) {
        if (!key) {
            throw new Error('Não foi possível atribuir uma chave vazia');
        }
        this.key = key;
    }

    private getType(): string {
        if (!this.type) {
            throw new Error('Não foi possível recuperar o tipo de storage');
        }
        return this.type;
    }

    private setType(type: string) {
        if (!['localStorage', 'sessionStorage'].includes(type)) {
            throw new Error('Tipo de storage inválido');
        }

        this.type = type;
    }

    private getStorage() {
        if (this.getType() === 'localStorage') {
            return localStorage;
        }

        if (this.getType() === 'sessionStorage') {
            return sessionStorage
        }

        throw new Error('Tipo de storage não definido');
    }

    private setDefaultValue(defaultValue: any) {
        this.defaultValue = defaultValue;
    }

    private getDefaultValue() {
        return this.defaultValue;
    }
}

const makeStorage = (key: string, type: string = 'localStorage', defaultValue: any = {}) => {
    return new Storage(key, type, defaultValue);
}

export default makeStorage;